import * as type from './type';
import util from 'common/js/util';

export default{
    //获取站内信消息列表
    [type.GET_LETTER_LIST](context, option){
        util.post({
            params: {
                functionId: 'getMsgList',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取站内信消息详情
    [type.GET_LETTER_DETAIL](context, option){
        util.post({
            params: {
                functionId: 'getMsgDetail',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取未读消息条数
    [type.GET_UNREAD_NUM](context, option){
        util.post({
            params: {
                functionId: 'getUnReadMsgNum',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //批量修改站内信消息已读状态
    [type.BATCH_SET_LETTER_READ](context, option){
        util.post({
            params: {
                functionId: 'batchAlterReadStatus',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
}



// WEBPACK FOOTER //
// ./src/store/letter/actions.js